<template>
  <div justify="center">
    <v-btn color="#033666" dark @click.stop="dialog = true">
      เพิ่ม permission
    </v-btn>

    <v-dialog v-model="dialog" persistent max-width="700">
      <v-card>
        <v-card-title>
          <span class="text-h5">Permission</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-row justify="center" align="center">
                <v-col cols="12" sm="3">role : </v-col>
                <v-col cols="12" sm="9"
                  ><v-text-field
                    v-model="pname"
                    outlined
                    dense
                    label="role"
                    :rules="[$store.getters.TextRule(pname)]"
                  ></v-text-field
                ></v-col>
              </v-row>

              <v-row
                v-for="(permission, i) in question_permission"
                :key="i"
                justify="center"
                align="center"
              >
                <v-col cols="12" sm="3">{{ i }} : </v-col>
                <v-col cols="12" sm="9">
                  <v-row no-gutters>
                    <v-col cols="12" v-if="!(typeof permission === 'object')">
                      <v-text-field
                        :value="permission"
                        outlined
                        dense
                        label="name"
                        :rules="[$store.getters.TextRule(permission)]"
                        @input="UpdateValue(i, $event)"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-else
                      v-for="(action, j) in permission"
                      :key="`${i}_${j}`"
                      cols="12"
                      sm="4"
                    >
                      <v-text-field
                        v-if="
                          typeof action === 'number' ||
                            typeof action === 'string'
                        "
                        v-model="permission[j]"
                        outlined
                        dense
                        label="name"
                      ></v-text-field>
                      <v-checkbox
                        v-if="typeof action === 'boolean'"
                        v-model="permission[j]"
                        :label="j"
                        hide-details=""
                        class="mt-0"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="validclose">
            ปิด
          </v-btn>
          <v-btn color="blue darken-1" text @click="CreatePermission">
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      dialog: false,
      pname: "",
      question_permission: {
        // limitSurvey: 100,
        survey: {
          enableControl: true,
          // create: true,
          update: true,
          delete: true,
        },
        question: {
          create: true,
          update: true,
          delete: true,
        },
        report: {
          view: true,
          download: true,
        },
        account: {
          view: true,
          update: true,
          delete: true,
          createInvite: true,
          createRole: true,
        },
      },
    };
  },
  methods: {
    UpdateValue(key, value) {
      this.question_permission[key] = value;
    },
    CreatePermission() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("CreatePermission", {
            role: this.pname,
            surveyID: this.$route.params.surveyID,
            permission: this.question_permission,
          })
          .then(() => {
            Swal.fire({
              icon: "success",
              text: "เพิ่มเรียบร้อยแล้ว",
              title: "",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              this.$store.dispatch("getPermission");
              this.validclose();
            });
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              icon: "error",
              text:
                error.data.message === "role is duplicate"
                  ? "มีการใช้ชื่อนี้ไปแล้ว"
                  : error.data.message === "Permission Denied"
                  ? "คุณไม่มีสิทธิ์เข้าถึงการเพิ่ม"
                  : "ไม่สามารถเพิ่มได้",
              title: "",
            }).then(() => {
              this.$store.commit("ToggleButtonLoading");
              this.$store.commit("ToggleLoading");
              if (error.data.message === "Permission Denied") {
                this.$store
                  .dispatch(
                    "getQuestionPermission",
                    this.$route.params.surveyID
                  )
                  .then(() => {
                    this.$router.push({
                      name: "question",
                    });
                  });
              }
            });
          });
      }
    },
    validclose() {
      this.dialog = false;
      this.pname = "";
      this.question_permission = {
        // limitSurvey: 100,
        survey: {
          enableControl: true,
          create: true,
          update: true,
          delete: true,
        },
        question: {
          create: true,
          update: true,
          delete: true,
        },
        report: {
          view: true,
          download: true,
        },
        account: {
          view: true,
          update: true,
          delete: true,
          createInvite: true,
          createRole: true,
        },
      };
      // this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
  },
};
</script>
